import { Star, MessageSquareQuote } from "lucide-react";
import Reveal from "@/components/Reveal";

export default function Reviews() {
  return (
    <section id="reviews" className="border-t border-bone/10 bg-navy py-16 sm:py-24">
      <div className="mx-auto flex max-w-[1600px] flex-col gap-10 px-5 sm:px-8 md:flex-row md:items-center md:justify-between">
        <Reveal>
          <div
            className="flex items-center gap-1.5"
            aria-label="5 star rating"
            data-testid="reviews-stars"
          >
            {[0, 1, 2, 3, 4].map((i) => (
              <Star key={i} className="h-5 w-5 fill-bone text-bone sm:h-6 sm:w-6" />
            ))}
          </div>
          <h2 className="mt-4 max-w-2xl font-display text-4xl font-black uppercase leading-[0.95] tracking-[0.02em] text-white sm:text-6xl">
            5-star service, straight from drivers like you.
          </h2>
          <p className="mt-4 max-w-xl text-base leading-relaxed text-bone/85 sm:text-lg">
            From daily drivers to full builds — read what Mopar owners say
            about working with us, or leave a review of your own.
          </p>
        </Reveal>

        <Reveal delay={0.12} className="flex shrink-0 flex-col gap-4 sm:flex-row md:flex-col">
          <a
            href="https://www.google.com/search?q=Dreamworlds+Garage+Dunnellon+FL+reviews"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="reviews-google-link"
            className="flex items-center justify-center gap-3 bg-bone px-8 py-4 font-display text-xl font-bold uppercase tracking-wide text-ink transition-colors duration-200 hover:bg-white"
          >
            <MessageSquareQuote className="h-5 w-5" />
            Read Google Reviews
          </a>
          <a
            href="https://www.facebook.com/dreamworldsgarage/"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="reviews-facebook-link"
            className="flex items-center justify-center gap-3 border border-bone/40 px-8 py-4 font-display text-xl font-bold uppercase tracking-wide text-bone transition-colors duration-200 hover:border-bone"
          >
            Reviews on Facebook
          </a>
        </Reveal>
      </div>
    </section>
  );
}
